import { render, staticRenderFns } from "./tablist2.vue?vue&type=template&id=7f2a76aa&scoped=true&"
import script from "./tablist2.vue?vue&type=script&lang=js&"
export * from "./tablist2.vue?vue&type=script&lang=js&"
import style0 from "./tablist2.vue?vue&type=style&index=0&id=7f2a76aa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f2a76aa",
  null
  
)

export default component.exports